<template>
  <div class="api-auth">
    <navigation>
      {{productDetail.productName}}
    </navigation>

    <pulldown-page
      :refresh="init"
      :is-scroll="true"
      background="#F7F7F7"
      color="#333333"
    >

      <main>
        <div class="main-product">
          <div class="header">
            <img :src="productDetail.icon" :alt="productDetail.productName">
            <span class="name">{{productDetail.productName}}</span>
            <p class="info"><span class="danger">{{productDetail.loanCounts}}</span>人已借款</p>
          </div>
          <div class="content">
            <span class="name">额度高达 (元) </span>
            <p class="amount">{{productDetail.configLimit |currency}}</p>
            <p class="exp">年化利率 {{productDetail.minYearRate}}%-{{productDetail.maxYearRate}}% <span class="padding-m">期限{{productDetail.minTerms}}-{{productDetail.maxTerms}}个月</span> </p>
          </div>
        </div>

        <div class="task-list">
          <nd-cell
            :icon="require('../images/base_2.png')"
            title="实名信息"
            :arrow="false"
            :class="['border-bottom',{bling:bling1}]"
          >
            <span slot="text" class="success" v-if="!productDetail.userOcrInfoStatus">已完成</span>
            <span slot="text" :class="['wait']" v-else  @click="$router.push(`/authentication/api-base?stepType=OCR`)">立即补充</span>
          </nd-cell>
          <nd-cell
            :icon="require('../images/base_1.png')"
            title="基础信息"
            :arrow="false"
            :class="['wait',{bling:bling2}]"
          >
            <span slot="text" class="success" v-if="!productDetail.userBaseStatus">已完成</span>
            <span slot="text" :class="['wait']" v-else  @click="$router.push(`/authentication/api-base?stepType=BASE`)">立即补充</span>
          </nd-cell>

          <!-- <nd-cell
            :icon="require('../images/icon_renlian@2x.png')"
            v-if="productDetail.needFace"
            title="补充人脸信息"
            :arrow="false"
          >
            <span slot="text" class="success" v-if="!productDetail.faceStatus ">已完成</span>
            <span slot="text" class="wait" v-else>未补充</span>
          </nd-cell> -->
        </div>
      </main>
      <footer class="footer">
        <nd-button class="btn " @click="blingControl" :loading="loading">提交资料，立获额度</nd-button>
        <div class="xie-yi"> 请在点击「提交资料，立获额度」前，仔细阅读产品<a @click="$router.push('/authentication/api-protocol')"> 《产品相关协议》《个人信息使用授权书》</a> </div>
      </footer>
    </pulldown-page>

    <!-- <nd-dialog v-model="authenticationVisible" class="auth-dialog" :footer="false" :closeBtn="true" >
      <div class="default-content">
        <iframe ref="authIframe" @load="IframeLoaded" class="iframe" :src="`${origin}/protocol/api-tqy?hideTitle=Y`" frameborder="0"></iframe>
    <nd-dialog v-model="authenticationVisible" class="auth-dialog" :footer="false" :closeBtn="true" >
      <div class="default-content protocol login-protocol" v-if="agreementDetail.joinStatus" >
        <div v-html ="agreementDetail.joinStatus"></div>
      </div>
      <div class="btn-wrapper">
        <nd-button class="btn" @click="agreeAuthentication">我已完成阅读并同意上述协议</nd-button>

      </div>
    </nd-dialog> -->


    <van-popup
      v-model="authenticationVisible"
      round
      position="bottom"
      class="api-popup"
    >
      <div class="api-popup-top">
        <span class="cancle" @click="authenticationVisible=false">取消</span>
      </div>
      <div class="api-popup-main">
        <div v-html ="agreementDetail.joinStatus"></div>
      </div>
      <div class="api-popup-foot">
        <nd-button class="popup-foot-btn" @click="agreeAuthentication" >确认</nd-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getKey } from '@/assets/utils'
import { mapActions } from 'vuex'
export default {
  name: 'apiAuth',
  data () {
    return {
      configIds: getKey('configIds'),
      productDetail: {},
      authenticationVisible: false,
      bling1: false,
      bling2: false,
      origin: window.location.origin,
      agreementDetail: {},
      loading: false

    }
  },
  async mounted () {
    try {
      await this.init()
      // 从人脸识别回来 直接跳转到结果页 不用手动触发
      if (this.$route.query.result) {
        this.agreeAuthentication()
      } else {
        this.$bus.$emit('ready')
      }
    } catch (e) {
      this.$bus.$emit('ready')
    }
  },
  computed: {
    btnText () {
      const { userOcrInfoStatus, userBaseStatus, faceStatus, needFace } = this.productDetail
      if (userOcrInfoStatus) {
        return '补充实名信息'
      } else if (userBaseStatus) {
        return '补充基础信息'
      } else if (faceStatus && needFace) {
        return '补充人脸信息'
      } else {
        return '提交资料，立获额度'
      }
    }
  },
  methods: {
    ...mapActions('apiDiversion', ['getProductInfo', 'creditApply', 'joinAgreement']),
    ...mapActions('user', ['protocolShow']),

    blingControl () {
      const { userOcrInfoStatus, userBaseStatus } = this.productDetail
      if (userOcrInfoStatus) {
        this.bling1 = true
        this.$message('请补充信息')
        setTimeout(() => {
          this.bling1 = false
        }, 30000)
      }

      if (userBaseStatus) {
        this.bling2 = true
        this.$message('请补充信息')
        setTimeout(() => {
          this.bling2 = false
        }, 30000)
      }

      if (!userOcrInfoStatus && !userBaseStatus) {
        this.$sensors.track('Withdraw_Element_Click', { product_type: 'diversion', product_code: JSON.stringify(this.configIds) })
        this.getJoinAgreement()
      }
    },
    IframeLoaded () {
      this.$nextTick(() => {
        this.$refs['authIframe'].contentWindow.postMessage({
          type: 'setFontSize',
          value: document.documentElement.style.fontSize
        }, '*')
      })
    },
    async agreeAuthentication () {
      if (this.loading) return

      const { faceStatus, needFace } = this.productDetail
      if (faceStatus && needFace) {
        return this.$router.replace(`/authentication/face?redirectUrl=/authentication/api-auth`)
      }
      // 上报设备信息 如果不成功则阻断
      this.loading = true
      const { data } = await this.sendDataForThird()
      if (!data.success) {
        this.loading = false
        return
      }
      const res = await this.creditApply({
        configIds: this.configIds
      })
      this.applayLoading = false
      if (res.success) {
        return this.$router.replace({
          path: '/authentication/api-result',
          query: {
            applyNo: res.data.applyNo
          }
        })
      }
      this.loading = false
    },
    async init () {
      const { success, data } = await this.getProductInfo({ configId: this.configIds[0], productInfo: false })
      if (success) {
        this.productDetail = data || {}
      }
    },
    async getJoinAgreement () {
      // 获取是否有弹窗开关
      this.loading = true
      const res = await this.protocolShow()
      if (res.success && res.data && res.data.show) {
        this.agreementDetail = {}
        const { success, data } = await this.joinAgreement({ configIds: this.configIds, busiType: 'CREDIT' })
        this.loading = false
        if (success) {
          this.agreementDetail = data || {}
          this.authenticationVisible = true
        }
      } else {
        this.loading = false
        this.agreeAuthentication()
      }
    }
  }
}
</script>
<style lang="less" src="./css/popup.less" scoped></style>
@import "../../../assets/less/mixin.less";


<style lang="less" scoped>
@import "../../../assets/less/mixin.less";


.api-auth {

  /deep/.nd-cell .nd-cell-header .icon {
    width:44px;
    height:44px;
  }
  .iframe {
      height: 638px;
      width: 100%;

      html {
          width: 100%;
      }
  }
  /deep/ .page {
    width: 750px;
    background: #f7f7f7;
    min-height: 100vh;
  }
  .padding-m {
    padding-left: 20px;
  }
  .btn-wrapper {
    position: fixed;
    background: white;
    height: 162px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 620px;
    border-radius: 0 0 30px 30px;
    transform: translateY(-20px);

    .btn {
      width: 500px;
    }
  }
  .main-product {
    width: 690px;
    height: 320px;
    background: #FFFFFF;
    border-radius: 20px;
    margin:30px auto ;
    padding: 30px;

    .header {
      display: flex;
      height: 90px;
      align-items: center;
      border-bottom: 1px solid #eee;
      img {
        width: 48px;
        height: 48px;
        margin-right: 10px;
        border-radius: 10px;
      }
      .name {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      .info {
        flex:1;
        font-size: 20px;
        text-align: right;
        .danger {
          color: #FF4633;
        }
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      padding: 10px 0;
      height: 180px;
      justify-content: space-around;
      .name {
        font-size: 24px;
      }
      .amount {
        font-size: 54px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
      }
      .exp {
        color: #999;
        font-size: 24px;
      }
    }
  }
  .task-list {
    border-radius: 20px;
    overflow: hidden;
    margin: 0 30px;
    &.bling{
      border:1px solid red
    }
    .success {
      color: #aaa;
    }
    .wait {
      color: #8EB2D8;
    }
    .nd-cell {
      border-bottom: 1px solid #eee;
    }
  }

  .footer {
    position: fixed;
    display: flex;
    flex-direction: column;
    padding: 20px 50px 40px;
    bottom: 0;
    align-items: center;
    width: 100%;
    left:0;
    background: #fff;
    .xie-yi {
      color: #999;
      font-size: 24px;
      padding: 30px 0px;
      a {
         color: #8EB2D8;
      }
    }
  }
}
.login-protocol {
  background-color: white;
  overflow-y: auto !important;
  height: 638px;
  width: 100%;
  position: relative;
  .content {
    padding: 0 48px;
    .title {
      font-weight: bolder;
      color: #333333;
      font-size: 28px;
      text-indent: 40px;
      line-height: 44px;
      margin-top: 10px;
    }
    .text {
      color: #333333;
      font-size: 28px;
      text-indent: 40px;
      line-height: 44px;
    }
    .text:last-child {
      margin-bottom: 10px;
    }
    .underline {
      text-indent: 40px;
      font-weight: bold;
      text-decoration: underline;
    }
    .underline:last-child {
      margin-bottom: 10px;
    }
  }
}
</style>
